import { render, staticRenderFns } from "./filters-sidebar.vue?vue&type=template&id=3094729c&scoped=true"
import script from "./filters-sidebar.vue?vue&type=script&lang=js"
export * from "./filters-sidebar.vue?vue&type=script&lang=js"
import style0 from "./filters-sidebar.vue?vue&type=style&index=0&id=3094729c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3094729c",
  null
  
)

export default component.exports